
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="基础示例" fileName="base.md" />
        <demo-block>
        <div><p><code>type=SEPARATOR</code>为分割线</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;div id=&quot;contextmenu-target&quot; ref=&quot;contextmenuTargetRef&quot;&gt;
            &lt;div&gt;右键点击此区域&lt;/div&gt;
            &lt;div style=&quot;font-size:30px;color:red;&quot;&gt;{{contextmenuType}}&lt;/div&gt;
        &lt;/div&gt;

        &lt;ve-contextmenu
            :eventTarget=&quot;eventTarget&quot;
            :options=&quot;options&quot;
            @on-node-click=&quot;contextmenuClick&quot;
        &gt;&lt;/ve-contextmenu&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                eventTarget: &quot;&quot;,
                // contextmenu type
                contextmenuType: &quot;&quot;,
                // contextmenu options
                options: [
                    {
                        label: &quot;menu1&quot;,
                        type: &quot;menu1-type&quot;,
                    },
                    {
                        label: &quot;menu2&quot;,
                        type: &quot;menu2-type&quot;,
                        children: [
                            {
                                label: &quot;menu2-1&quot;,
                                type: &quot;menu2-1-type&quot;,
                            },
                            {
                                label: &quot;menu2-2&quot;,
                                type: &quot;menu2-2&quot;,
                            },
                        ],
                    },
                    {
                        type: &quot;SEPARATOR&quot;,
                    },
                    {
                        label: &quot;menu3&quot;,
                        type: &quot;menu3-type&quot;,
                    },
                    {
                        label: &quot;menu4&quot;,
                        disabled: true,
                        children: [
                            {
                                label: &quot;menu4-1&quot;,
                                type: &quot;menu4-1-type&quot;,
                            },
                        ],
                    },
                    {
                        label: &quot;menu5&quot;,
                        type: &quot;menu5-type&quot;,
                        children: [
                            {
                                label: &quot;menu5-1&quot;,
                                type: &quot;menu5-1-type&quot;,
                                children: [
                                    {
                                        label: &quot;menu5-1-1&quot;,
                                        type: &quot;menu5-1-1-type&quot;,
                                        children: [
                                            {
                                                label: &quot;menu5-1-1-1&quot;,
                                                type: &quot;menu5-1-1-1-type&quot;,
                                            },
                                            {
                                                label: &quot;menu5-1-1-2&quot;,
                                                type: &quot;menu5-1-1-2-type&quot;,
                                            },
                                        ],
                                    },
                                    {
                                        label: &quot;menu5-2-2&quot;,
                                        type: &quot;menu5-2-2-type&quot;,
                                    },
                                ],
                            },
                            {
                                label: &quot;menu5-2&quot;,
                                disabled: true,
                            },
                            {
                                type: &quot;SEPARATOR&quot;,
                            },
                            {
                                label: &quot;menu5-3&quot;,
                                type: &quot;menu5-3-type&quot;,
                            },
                        ],
                    },
                    {
                        label: &quot;menu6&quot;,
                        type: &quot;menu6-type&quot;,
                        disabled: true,
                    },
                ],
            };
        },
        methods: {
            contextmenuClick(type) {
                this.contextmenuType = type;
            },
        },
        mounted() {
            /* 
            eventTarget can be the following case:
            1、this.eventTarget = &quot;#contextmenu-target&quot;;
            2、this.eventTarget = document.querySelector('#contextmenu-target');
            3、this.eventTarget = this.$refs[&quot;contextmenuTargetRef&quot;];
            */
            this.eventTarget = this.$refs[&quot;contextmenuTargetRef&quot;];
        },
    };
&lt;/script&gt;
&lt;style&gt;
    #contextmenu-target {
        display: flex;
        flex-direction: column;
        width: 300px;
        height: 300px;
        justify-content: center;
        align-items: center;
        background: #eee;
        border: 3px dashed #666;
        border-radius: 8px;
    }
&lt;/style&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('div',{ref:"contextmenuTargetRef",attrs:{"id":"contextmenu-target"}},[_c('div',[_vm._v("右键点击此区域")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"30px","color":"red"}},[_vm._v(_vm._s(_vm.contextmenuType))])]),_vm._v(" "),_c('ve-contextmenu',{attrs:{"eventTarget":_vm.eventTarget,"options":_vm.options},on:{"on-node-click":_vm.contextmenuClick}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                eventTarget: "",
                // contextmenu type
                contextmenuType: "",
                // contextmenu options
                options: [
                    {
                        label: "menu1",
                        type: "menu1-type",
                    },
                    {
                        label: "menu2",
                        type: "menu2-type",
                        children: [
                            {
                                label: "menu2-1",
                                type: "menu2-1-type",
                            },
                            {
                                label: "menu2-2",
                                type: "menu2-2",
                            },
                        ],
                    },
                    {
                        type: "SEPARATOR",
                    },
                    {
                        label: "menu3",
                        type: "menu3-type",
                    },
                    {
                        label: "menu4",
                        disabled: true,
                        children: [
                            {
                                label: "menu4-1",
                                type: "menu4-1-type",
                            },
                        ],
                    },
                    {
                        label: "menu5",
                        type: "menu5-type",
                        children: [
                            {
                                label: "menu5-1",
                                type: "menu5-1-type",
                                children: [
                                    {
                                        label: "menu5-1-1",
                                        type: "menu5-1-1-type",
                                        children: [
                                            {
                                                label: "menu5-1-1-1",
                                                type: "menu5-1-1-1-type",
                                            },
                                            {
                                                label: "menu5-1-1-2",
                                                type: "menu5-1-1-2-type",
                                            },
                                        ],
                                    },
                                    {
                                        label: "menu5-2-2",
                                        type: "menu5-2-2-type",
                                    },
                                ],
                            },
                            {
                                label: "menu5-2",
                                disabled: true,
                            },
                            {
                                type: "SEPARATOR",
                            },
                            {
                                label: "menu5-3",
                                type: "menu5-3-type",
                            },
                        ],
                    },
                    {
                        label: "menu6",
                        type: "menu6-type",
                        disabled: true,
                    },
                ],
            };
        },
        methods: {
            contextmenuClick(type) {
                this.contextmenuType = type;
            },
        },
        mounted() {
            /* 
            eventTarget can be the following case:
            1、this.eventTarget = "#contextmenu-target";
            2、this.eventTarget = document.querySelector('#contextmenu-target');
            3、this.eventTarget = this.$refs["contextmenuTargetRef"];
            */
            this.eventTarget = this.$refs["contextmenuTargetRef"];
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      #contextmenu-target {
        display: flex;
        flex-direction: column;
        width: 300px;
        height: 300px;
        justify-content: center;
        align-items: center;
        background: #eee;
        border: 3px dashed #666;
        border-radius: 8px;
    }
    </style>
  